import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useIsMobile from '../../hooks/useIsMobile'; // path as needed


const Footer = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
    const isMobile = useIsMobile(); // <= here!


  return (
    <footer className="bg-primary-950 text-neutral-100 py-12">
      <div className="container mx-auto px-4">
        <div
          className={
            "grid grid-cols-1 md:grid-cols-3 gap-8 " +
            (isRTL ? "text-center md:text-right"  : "text-center md:text-left")
          }
        >
          {/* Mission Section */}
          <div className={`flex flex-col items-center md:items-start`}>
            <h3 className="text-2xl font-bold mb-4 font-display">DABV</h3>
            <p className="max-w-xs">
              {t('footer.mission')}
            </p>
          </div>

          {/* Quick Links */}
          <div className={`flex flex-col items-center md:items-start`}>
            <h4 className="text-lg font-semibold mb-4 border-b border-accent-600 pb-2 inline-block">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/about" 
                  className="hover:text-accent-400 transition-colors duration-200"
                >
                  {t('footer.about')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/services" 
                  className="hover:text-accent-400 transition-colors duration-200"
                >
                  {t('footer.services')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/courses" 
                  className="hover:text-accent-400 transition-colors duration-200"
                >
                  {t('footer.courses')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="hover:text-accent-400 transition-colors duration-200"
                >
                  {t('footer.contact')}
                </Link>
              </li>
               <li>
                  <Link 
                    to="/satzung" 
                    className="hover:text-accent-400 transition-colors duration-200"
                  >
                    Satzung
                  </Link>
                </li>
            </ul>
          </div>
          {/* Contact Info */}
          {/* Contact Info */}
<div 
  className="flex flex-col items-center md:items-start"
  dir={isMobile ? 'ltr' : undefined}
>
  <h4 className="text-lg font-semibold mb-4 border-b border-accent-600 pb-2 inline-block">
    {t('footer.contact')}
  </h4>
  <div className={`space-y-2 ${isMobile && 'place-items-center'} text-left`}>
    <p className="flex items-center gap-2">
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
      {t('footer.email')}
    </p>
    <p className="flex items-center gap-2" >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
      </svg>
      {t('footer.phone')}
    </p>
  </div>
</div>

        </div>

        {/* Copyright Section */}
        <div className="border-t border-primary-800 mt-12 pt-6 text-center">
          <p className="text-sm text-neutral-400">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
